import type { ReactNode } from 'react';

type MailEmptyStateProps = {
  illustration?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
};

export default function MailEmptyState({
  illustration,
  title,
  description,
  action,
}: MailEmptyStateProps) {
  return (
    <div className="flex w-full flex-col items-center gap-md px-md pt-16 pb-md">
      {illustration && (
        <div className="flex h-[125px] w-[137px] items-center justify-center">{illustration}</div>
      )}
      <div className="flex flex-col items-center gap-xs text-center text-main">
        <p className="text-heading-xs">{title}</p>
        {description && <div className="text-body-sm">{description}</div>}
      </div>
      {action}
    </div>
  );
}
